/* ======================================
   HIDE STICKY ATC WHEN CART DRAWER IS OPEN
====================================== */

(function () {
  const sticky = document.getElementById("sticky-atc");
  const cartDrawer = document.getElementById("CartDrawer");

  if (!sticky || !cartDrawer) return;

  const updateStickyVisibility = () => {
    const cartOpen = cartDrawer.classList.contains("is-active");

    sticky.classList.toggle("is-hidden-by-cart", cartOpen);
  };

  // Observe cart drawer class changes
  const observer = new MutationObserver(updateStickyVisibility);

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });

  // Run once on load (important)
  updateStickyVisibility();
})();
